import BaseViewController from "../base-view-controller";
import { warningMessageType } from "../../resource/warning-message-type";

import {
  MIN_TIME_RANGE,
  setWarning,
  removeWarning
} from "../../utils/do-not-disturb-hours-helpers";

class DoNotDisturbHoursViewController extends BaseViewController {
  preprocessScreenData() {
    super.preprocessScreenData();

    const { fields, footerFields } = this.screen;

    const container = fields.find(f => f.name === "time_range_section")
      .fieldLayouts[0].containerFields;
    const webWarningInvalidRange = container.find(
      f => f.name === "web_warning_invalid_range"
    );
    const webWarningRangeTooShort = container.find(
      f => f.name === "web_warning_range_too_short"
    );

    const saveButton = footerFields[0];

    const startTimeInput = document.getElementById(
      "do_not_disturb_hours_start_time-input"
    );
    const startTimeLabel = document.getElementById(
      "do_not_disturb_hours_start_time-label"
    );
    const endTimeInput = document.getElementById(
      "do_not_disturb_hours_end_time-input"
    );
    const endTimeLabel = document.getElementById(
      "do_not_disturb_hours_end_time-label"
    );

    const startTimeValue = this.appData.values.do_not_disturb_hours_start_time;
    const endTimeValue = this.appData.values.do_not_disturb_hours_end_time;

    const parseTimeOverMidnight = time => {
      return time.startsWith("0")
        ? Date.parse(`10-11-2020 ${time}`)
        : Date.parse(`10-10-2020 ${time}`);
    };

    if (
      startTimeValue === null ||
      endTimeValue === null ||
      startTimeLabel === null ||
      endTimeLabel === null
    )
      return;

    const startTime = parseTimeOverMidnight(startTimeValue);
    const endTime = parseTimeOverMidnight(endTimeValue);

    if (startTime > endTime) {
      setWarning(startTimeLabel, startTimeInput, saveButton);
      setWarning(endTimeLabel, endTimeInput, saveButton);

      webWarningInvalidRange.type = warningMessageType.text;
      webWarningRangeTooShort.type = warningMessageType.hidden;
    } else if (endTime - startTime < MIN_TIME_RANGE) {
      setWarning(startTimeLabel, startTimeInput, saveButton);
      setWarning(endTimeLabel, endTimeInput, saveButton);

      webWarningInvalidRange.type = warningMessageType.hidden;
      webWarningRangeTooShort.type = warningMessageType.text;
    } else {
      removeWarning(startTimeLabel, startTimeInput, saveButton);
      removeWarning(endTimeLabel, endTimeInput, saveButton);

      webWarningInvalidRange.type = warningMessageType.hidden;
      webWarningRangeTooShort.type = warningMessageType.hidden;
    }
  }
}

export default DoNotDisturbHoursViewController;
